import React, { useContext } from 'react';
import {
  Progress,
  Typography
} from 'antd';
import { red, green } from '@ant-design/colors';
import { ThemeContext, ThemeContextState } from '../../context/ThemeContext';
import styles from './ProblemTestcaseProgress.module.css';

export interface ProblemTestcaseProgressProps {
  passedTestcases: number
  totalTestcases: number
};

// progress bar to visualize testcase progress
const ProblemTestcaseProgress = (props: ProblemTestcaseProgressProps): JSX.Element | null => {
  // get current theme from theme context
  const { theme } = useContext(ThemeContext) as ThemeContextState;

  return (
    <Progress
        percent={Math.floor((props.passedTestcases * 100) / props.totalTestcases)}
        steps={props.totalTestcases}
        strokeColor={green[6]}
        trailColor={red[6]}
        format={() => (
          <Typography.Text
            className={`${styles.text} ${theme === 'light' ? styles.textLight : styles.textDark}`}
          >
            {`${props.passedTestcases}/${props.totalTestcases} testcases passed`}
          </Typography.Text>
        )}
      />
  );
};

export default ProblemTestcaseProgress;
